import React from "react";
import ProductBySlugPage from "~/src/components/product/pages/ProductBySlugPage";

export default function ProductPage() {
  return <ProductBySlugPage />;
}
